import { equals, makeFilter, mergeFilters, notEquals } from '@/utils/dynamic'

const checkHasTD = (data, root) => {
  const { repairTearDowns = [], partID, partSN, rfqid } = data
  return repairTearDowns.some((item) => {
    return [partID === item.partID, partSN === item.partSN, rfqid === item.rfqid].every((v) => v)
  })
}
const checkShowCreateTD = (data, root) => {
  return !checkHasTD(data, root)
}
const checkShowDetails = (data, root) => {
  return checkHasTD(data, root)
}

export default {
  id: 'repair-exchange-td',
  mode: {
    isModalNew: true,
    isModalPush: true
  },
  store: {
    get: {
      url: 'RFQ3s/GetAllDynamic',
      selected: [
        'id', 'id as rfq3ID',

        'rfqid',
        '(rfq.customerCompany != null) ? rfq.customerCompany.id : null as companyID',
        'rfq.customerCompany.name as companyName',

        '(rfq.rfqType != null) ? rfq.rfqType.id : null as rfqTypeID',

        'rfq.rfqType.Title as rfqTypeTitle',

        'rfq.po', 'rfq.poDate', 'part.id as partID',
        'part.partNumber as partNumber', 'part.partDescription as partDescription', 'partSN',

        'conditionID',
        'condition.Title as conditionTitle', 'rfq.repairTearDowns'
      ],
      filters: mergeFilters(
        '(((rfq.rfqTypeID == 3 || rfq.rfqTypeID == 7 || rfq.rfqTypeID == 8) && exchangeCoreReceived == true) || (rfq.rfqTypeID == 1 || rfq.rfqTypeID == 5))',
        makeFilter('chosen', true, equals),
        makeFilter('rfq.poIsOpen', true, equals),
        makeFilter('rfq.po', null, notEquals)
      ).join('&&')
    },
    create: {
      url: 'RFQ3s/Create'
    },
    patch: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'RFQ3s/Patch/${data.id}'
    },
    delete: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'RFQ3s/Delete/${data.id}',
      modal: {
        msgDataKey: 'partSN'
      }
    }
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      },
      addNew: {
        isVisible: false
      }
    }
  },
  sortable: {
    field: 'poDate',
    order: 'desc'
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("po-date")}',
      field: 'poDate',
      template: 'date',
      sortable: {
        custom: 'rfq.poDate'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("rfq-type")}',
      field: 'rfqTypeTitle',
      sortable: {
        custom: 'rfq.rfqType.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("customer")}',
      field: 'companyName',
      sortable: {
        custom: 'rfq.customerCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("po")}',
      field: 'po',
      sortable: {
        custom: 'rfq.po'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-number')}",
      field: 'partNumber',
      sortable: {
        custom: 'part.partNumber'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-SN")}',
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("condition")}',
      field: 'conditionTitle',
      sortable: {
        custom: 'condition.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      'title': '${root.L10n("rfqid")}',
      'field': 'rfqid'
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          valueTemplate: '(rfq.rfqType.title.contains("${data.value}") || rfq.customerCompany.name.StartsWith("${data.value}")  || rfq.po.contains("${data.value}") || part.partNumber.StartsWith("${data.value}") || partSN.contains("${data.value}") || condition.title.contains("${data.value}") ||  rfqid.contains("${data.value}") )',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("search")}',
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'select',
        field: 'rfq.rfqTypeID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("rfq-type")}',
        options: {
          dataSource: 'RfqTypes/GetAllDynamic?select=id,title&filter=(id == 3 || id == 7 || id == 8 || id == 1 || id == 5)',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          // eslint-disable-next-line no-template-curly-in-string
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'rfq.customerCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("customer")}',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'name.StartsWith("${data.search}")',
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name',
            take: 50
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            minWidth: '25rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'partID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("part")}',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'partNumber.StartsWith("${data.search}")',
          dataSource: {
            url: 'Parts/GetAllDynamic',
            selected: 'id,partNumber',
            take: 50
          },
          option: {
            label: 'partNumber'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          styles: {
            minWidth: '10rem'
          }
        }
      },
      {
        type: 'select',
        field: 'conditionID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("condition")}',
        options: {
          dataSource: 'Conditions/GetAllDynamic?select=id,title&orderBy=title asc',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        id: 'employeeID',
        type: 'select',
        field: 'rfq.baxEmployeeID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("sales-person")}',
        permissions: {
          enable: 'isAllowToViewQuickRFQByParts'
        },
        options: {
          dataSource: 'Employees/GetAllDynamic?select=id,name as title&filter=isActive==true',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          styles: {
            minWidth: '17rem'
          }
        }
      }
    ]
  },
  rowControls: {
    right: {
      classes: 'controls-inline',
      controls: [
        {
          type: 'edit',
          // eslint-disable-next-line no-template-curly-in-string
          isVisible: checkShowDetails
        },
        {
          type: 'custom',
          // eslint-disable-next-line no-template-curly-in-string
          isVisible: checkShowCreateTD,
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('create-td')}"
        }
      ]
    }
  },
  pagination: {
    size: 200,
    sizes: {
      isVisible: true,
      values: [
        {
          label: '10',
          value: 10
        },
        {
          label: '15',
          value: 15
        },
        {
          label: '25',
          value: 25
        },
        {
          label: '50',
          value: 50
        },
        {
          label: '100',
          value: 100
        },
        {
          label: '200',
          value: 200
        }
      ]
    }
  }
}
